var _excluded = ["border", "background", "className", "content", "children", "customStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import useStyles from './use_styles';
import { jsx } from '@emotion/react';
import { useTheme } from '@veneer/theme';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import useAppearance from '../utils/use_appearance';
import { getComponentDisplayName } from '../utils/forward_props';
export var cardClass = '__vn-card';
var cardAs = function cardAs(component) {
  var interactive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var displayName = getComponentDisplayName(component, 'Card');
  var Wrapped = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    var {
        border: borderProp = 'none',
        background: backgroundProp = 'transparent',
        className,
        content,
        children = content,
        customStyle
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    var theme = useTheme();
    var style = useStyles();
    var {
      background,
      border
    } = useAppearance({
      background: backgroundProp,
      border: borderProp
    });
    var isPill = theme.shape === 'pill';
    var isHc = theme.mode === 'contrast';
    var isFilled = background === 'filled';
    var isOutlined = border === 'outlined';
    var isShadowed = border === 'dropShadow';
    return jsx(component, _objectSpread({
      ref,
      className: [className, cardClass].filter(Boolean).join(' '),
      css: [style.root, isFilled && style.filled, isShadowed && style.shadowed, isOutlined && style.outlined, interactive && style.interactive, isHc && [style.contrast, interactive && style.contrastAndInteractive], isPill && style.pill, customStyle, highContrastMediaQuery(theme)]
    }, props), children);
  });
  Wrapped.displayName = displayName;
  return Wrapped;
};
export default cardAs;